import {combineReducers} from 'redux';
import {
  searchresults,
  lastadjustments,
  structure,
  structures,
  article,
  element,
  tags,
  annotation,
  elementAnnotations,
  annotatedTexts,
  structureVersions,
  articleVersions,
  articleCompare,
  elementVersions
} from '../modules/search/reducers';
import * as ui from '../modules/ui/reducers';
import * as print from '../modules/print/reducer';
import {intlReducer} from 'react-intl-redux';
import * as router from '../modules/routing/reducers';

const senaatApp = combineReducers({
  searchresults,
  lastadjustments,
  structure,
  structures,
  article,
  element,
  elementAnnotations,
  tags,
  annotation,
  annotatedTexts,
  structureVersions,
  elementVersions,
  articleVersions,
  articleCompare,
  intl: intlReducer,
  ui: combineReducers(ui),
  print: print.print,
  printQueue: print.printQueue,
  router: combineReducers(router)
});

export default senaatApp;



/** WEBPACK FOOTER **
 ** ./src/reducers/index.js
 **/